/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Portals_Bump_EnabledInputs */

const cs_portals_bump_enabled = /** @type {(inputs: Portals_Bump_EnabledInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bump zapnut`)
};

const en_portals_bump_enabled = /** @type {(inputs: Portals_Bump_EnabledInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bump enabled`)
};

/**
* | output |
* | --- |
* | "Bump enabled" |
*
* @param {Portals_Bump_EnabledInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const portals_bump_enabled = /** @type {((inputs?: Portals_Bump_EnabledInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Portals_Bump_EnabledInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_portals_bump_enabled(inputs)
	return cs_portals_bump_enabled(inputs)
});